import { all, takeEvery, put } from "redux-saga/effects";
import { DELETE_SURVEY, GET_BOT_SETTINGS, GET_FAQS, GET_SMALL_TALKS, GET_SURVEY, GET_SYSTEM_VARS, POST_SURVEY, UPDATE_BOT_SETTINGS, UPDATE_SURVEY } from "../constants/Bot";
import { saveSurvey, getSurvey as getSurveyApi, saveSystemVars, saveFaqs, saveSmallTalks, saveBotSettings, getBotSettings, setBotSettingsLoading, setBotSettingsUpdating } from "../actions/Bot";
import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";
import { message } from "antd";

export function* getSurvey() {
    yield takeEvery(GET_SURVEY, function* () {
        try {
            const res = yield ApiService.get("/hulk/api/v1/surveys");
            if (res && res.status === "success") {
                yield put(saveSurvey(res.data))
            }
        } catch (error) {
            toastNotification({ res: null, errorMessage: "Unable to load surveys" });
        }
    });
}

export function* postSurvey() {
    yield takeEvery(POST_SURVEY, function* (action) {
        try {
            const res = yield ApiService.post("/hulk/api/v1/surveys", {}, action.payload);
            if (res && res.status == "success") {
                toastNotification({res: null, successMessage: "Created survey successfully"});
                yield put(getSurveyApi());
            }
        } catch (error) {
            console.error("err", error);
            toastNotification({ res: null, errorMessage: "Unable to save survey" });
        }
    });
}

export function* updateSurvey() {
    yield takeEvery(UPDATE_SURVEY, function* (action) {
        try {
            const res = yield ApiService.put(`/hulk/api/v1/surveys/${action.payload.id}`, {}, action.payload.data);
            if (res && res.status == "success") {
                toastNotification({res: null, successMessage: "Updated survey successfully"});
                yield put(getSurveyApi());
            }
        } catch (error) {
            console.error("err", error);
            toastNotification({ res: null, errorMessage: "Unable to update survey" });
        }
    });
}
export function* deleteSurvey() {
    yield takeEvery(DELETE_SURVEY, function* (action) {
        try {
            const res = yield ApiService.delete(`/hulk/api/v1/surveys/${action.payload}`);
            if (res && res.status == "success") {
                toastNotification({res: null, successMessage: "Survey deleted successfully"});
                yield put(getSurveyApi());
            }
            else{
                toastNotification({ res: null, errorMessage: "Unable to delete survey" });
            }
        } catch (error) {
            toastNotification({ res: null, errorMessage: "Unable to delete survey" });
        }
    });
}

export function* getSystemVariables() {
    yield takeEvery(GET_SYSTEM_VARS, function* () {
        try {
            const res = yield ApiService.get("/ironman/crm-schemas", {}, {
                filter: {
					fields: {
						schema: true
					}
				}
            })
            if (res && res.status == "success") {
                yield put(saveSystemVars(res.data))
            }
        } catch (error) {
            console.log(error)
            toastNotification({ res: null, errorMessage: "Unable to load variables" });
        }
    });
}
export function* getBotFaqs() {
    yield takeEvery(GET_FAQS, function* (action) {
        try {
            const res = yield ApiService.get(`/jarvis/api/v1/intent/${action.payload}`)
            if (res && res.status == "success") {
                yield put(saveFaqs(res.data.intents))
            }
        } catch (error) {
            console.log(error)
            toastNotification({ res: null, errorMessage: "Unable to fetch faqs" });
        }
    });
}
export function* getBotSmallTalks() {
    yield takeEvery(GET_SMALL_TALKS, function* (action) {
        try {
            const res = yield ApiService.get(`/jarvis/api/v1/intent/${action.payload}`)
            if (res && res.status == "success") {
                yield put(saveSmallTalks(res.data.intents))
            }
        } catch (error) {
            console.log(error)
            toastNotification({ res: null, errorMessage: "Unable to fetch small talks" });
        }
    });
}
export function* getBotSettingsSaga() {
    yield takeEvery(GET_BOT_SETTINGS, function* (action) {
        try {
            yield put(setBotSettingsLoading(true))
            const res = yield ApiService.get("/hulk/api/v1/bot-settings");
            if (res && res.status == "success") {
                yield put(saveBotSettings({...res.data[0]}))
                yield put(setBotSettingsLoading(false))
                yield put(setBotSettingsUpdating(false));

            }
        } catch (error) {
            yield put(setBotSettingsLoading(false))
            toastNotification({ res: null, errorMessage: "Unable to fetch bot settings" });
        }
    });
}
export function* updateBotSettings() {
    yield takeEvery(UPDATE_BOT_SETTINGS, function* (action) {
        try {
            yield put(setBotSettingsUpdating(true));
            const res = yield ApiService.put(
                `/hulk/api/v1/bot-settings/${action.payload.id}`,
                {},
                { ...action.payload.settings }
            );
            if (res && res.status == "success") {
                message.success("Settings Updated Successfully");
                
                yield put(getBotSettings());

            }
        } catch (error) {
            console.log(error)
            toastNotification({ res: null, errorMessage: "Unable to update bot settings" });
            yield put(setBotSettingsUpdating(false));

        }
    });
}

export default function* rootSaga() {
    yield all([
        getSurvey(),
        postSurvey(),
        updateSurvey(),
        getSystemVariables(),
        deleteSurvey(),
        getBotFaqs(),
        getBotSmallTalks(),
        getBotSettingsSaga(),
        updateBotSettings()
    ]);
}
